module.exports = __webpack_public_path__ + "img/Mask Group (4).31813cc5.png";